const textColor = (name) => {
  switch (name) {
    case 'daxiao_da':
    case 'danshuang_shuang':
    case 'longHu_long':
    case 'maJiang_jhong':
    case 'fangSiang_nan':
    case 'daXiaoPan_xiao':
    case 'danShuangPan_shuang':
      return 'text-red'
    case 'danShuangPan_he':
      return 'text-green'
    default:
      return ''
  }
}

const textColorWeb = (name) => {
  switch (name) {
    case 'daxiao_da':
    case 'danshuang_shuang':
    case 'longHu_long':
    case 'maJiang_jhong':
    case 'fangSiang_nan':
    case 'daXiaoPan_xiao':
    case 'danShuangPan_shuang':
      return 'red'
    case 'danShuangPan_he':
      return 'green'
    default:
      return ''
  }
}

export {
  textColor,
  textColorWeb
}
